import { Outlet } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';
import { colors } from '@/lib/designSystem';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

const Layout = () => {
  const { theme } = useTheme();
  const currentColors = colors[theme];

  return (
    <div
      className="flex h-screen overflow-hidden transition-colors duration-300"
      style={{ background: currentColors.background }}
    >
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main className="flex-1 overflow-auto pb-20 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default Layout;
